import { useId } from 'react';
import { displayExcelValue, type ExcelValueConflict } from '../../../utils/excel-import-conflicts';

type Props = {
  conflicts: ExcelValueConflict[];
  selections: Record<string, string>;
  onChange: (selections: Record<string, string>) => void;
  disabled?: boolean;
};

export default function ExcelConflictFields({ conflicts, selections, onChange, disabled }: Props) {
  const id = useId();
  if (!conflicts.length) return null;
  return (
    <section className="govuk-!-margin-top-5">
      <h3 className="govuk-heading-m">Choose values to import</h3>
      <p className="govuk-body">
        These files contain different answers. Choose a value for each field before continuing.
      </p>
      {conflicts.map((conflict, index) => (
        <div className="govuk-form-group" key={conflict.key}>
          <label className="govuk-label" htmlFor={`${id}-${index}`}>
            {conflict.label}
          </label>
          <select
            id={`${id}-${index}`}
            className="govuk-select"
            style={{ width: '100%', minWidth: 0 }}
            disabled={disabled}
            value={selections[conflict.key] ?? ''}
            onChange={(event) => onChange({ ...selections, [conflict.key]: event.target.value })}
          >
            <option value="">Choose a value</option>
            {conflict.options.map((option, optionIndex) => (
              <option key={optionIndex} value={optionIndex}>
                {option.source}: {displayExcelValue(option.value)}
              </option>
            ))}
          </select>
        </div>
      ))}
    </section>
  );
}
